import { SpyneTrait, DomElementTemplate } from "spyne";
import { ModalData } from "traits/utils/modal-data";
import AttributesTmpl from "../components/ui/templates/modal-templates/modal-template-attributes.tmpl.html";

import broadcastEventsTmpl from "../components/ui/templates/modal-templates/modal-template-broadcast-events.tmpl.html";
import configRootTmpl from "../components/ui/templates/modal-templates/modal-template-config-root.tmpl.html";
import configRouteTmpl from "../components/ui/templates/modal-templates/modal-template-config-route.tmpl.html";
import configWindowTmpl from "../components/ui/templates/modal-templates/modal-template-config-window.tmpl.html";
import SuccessTmpl from "../components/ui/templates/modal-templates/modal-template-success.tmpl.html";
import MessageTmpl from "../components/ui/templates/modal-templates/modal-template-message.tmpl.html";

//const {htmlElementsWithAttributes} = require("../")

export class ModalWindowTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "modalWindow$";

    super(context, traitPrefix);
  }

  static modalWindow$GetDataByAttribute(modalType, data = this.props.data) {
    return data.filter((d) => d.modalType === modalType)[0];
  }

  static modalWindow$AddBodyContent(modalType, props = this.props) {




    const data = modalType === 'message' ?
        this.props.data :
        this.modalWindow$GetDataByAttribute(modalType, ModalData);

    //const data = this.modalWindow$GetDataByAttribute(modalType, ModalData);

    const template =
      ModalWindowTraits.modalWindow$GetBodyContentTemplate(modalType);

    const htmlStr = new DomElementTemplate(template, data).renderToString();

    props.el$(".modal-window-content-body").el.innerHTML = htmlStr;
   //console.log("HTML STR IS ", {modalType,ModalData, props, data, template, htmlStr});
  }

  static modalWindow$GetBodyContentTemplate(modalType) {
    const tmplHash = {
      attributes: AttributesTmpl,
      broadcastEvents: broadcastEventsTmpl,
      root: configRootTmpl,
      route: configRouteTmpl,
      window: configWindowTmpl,
      success: SuccessTmpl,
      message: MessageTmpl
    };

    return tmplHash[modalType];
  }

  static modalWindow$HelloWorld() {
    return "Hello World";
  }
}
